/* Only e-mail is needed for the backend – name & phone are commented */
import React from "react";
import CreateOrganizationcss from "../../CreateOrgMain/CreateOrganization.module.css";
import BenevvTextField from "components/forms/BenevvTextField/BenevvTextField";

interface Props {
  /* setName?: (v: string) => void;   // ❌ BACKEND NOT USED – commented for now */
  /* setPhone?: (v: string) => void;  // ❌ BACKEND NOT USED – commented for now */
  setEmail: (v: string) => void;
}

const StackedField = ({ label, children }: { label: React.ReactNode; children: React.ReactNode }) => (
  <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 46%', minWidth: 260, maxWidth: '46%', marginBottom: '1.25rem' }}>
    <label style={{ color: '#fe2f67', fontSize: '1.05rem', marginBottom: 6, whiteSpace: 'nowrap' }}>{label}</label>
    {children}
  </div>
);

export function PrimaryContactInfo({ setEmail }: Props) {
  return (
    <>
      <h2 className={CreateOrganizationcss.sectionHeader}>
        1. Primary Contact Info
      </h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem' }}>
        <StackedField label="Organization Email Address *">
          <BenevvTextField
            styleInput={{ width: "100%", height: "3rem", minHeight: "3rem", maxHeight: "3rem", padding: "0.5rem 1.25rem", boxSizing: "border-box" }}
            htmlFor="email"
            placeholder="Enter email address"
            required
            email
            setTextField={setEmail}
            maxLength={100}
          />
        </StackedField>
      </div>
    </>
  );
}
